import { LearningItemStatus } from '../../models/BaseModels'
import * as api from '../api'
import useInvalidate from '../useInvalidate'
import useApiMutation from './useApiMutation'

type UpdateScheduledCourseArgs = {
  status?: LearningItemStatus
  uuid: string
  title?: string
  description?: string
  image?: string | null | undefined
  categoryUuids?: string[]
  providerUuid?: string
  isGlobalProvider?: boolean
  clientUuid?: string | null | undefined
  createCertificate?: boolean
  certificateValidUntil?: Date | null | undefined
  events?: {
    uuid: string
    maxAttendees: number
    dates: {
      uuid: string
      title: string
      trainers: string[]
      startDate: Date
      endDate: Date
      meetingLink: string | null | undefined
      meetingAddress: string | null | undefined
    }[]
  }[]
}

export default function useUpdateScheduledCourse() {
  const invalidate = useInvalidate()

  return useApiMutation({
    mutationFn: async (data: UpdateScheduledCourseArgs) => {
      const result = await api.patch(`scheduled-course/${data.uuid}`, {
        status: data.status,
        title: data.title,
        description: data.description,
        image: data.image,
        categories: data.categoryUuids,
        provider_uuid: data.providerUuid,
        is_global_provider: data.isGlobalProvider,
        client_uuid: data.clientUuid,
        create_certificate: data.createCertificate,
        certificate_valid_until: data.certificateValidUntil,
        events: data.events?.map((event) => ({
          uuid: event.uuid,
          max_attendees: event.maxAttendees,
          dates: event.dates.map((date) => ({
            uuid: date.uuid!,
            title: date.title,
            trainer: date.trainers,
            start_date: date.startDate,
            end_date: date.endDate,
            meeting_link: date.meetingLink,
            address: date.meetingAddress,
          })),
        })),
      })

      invalidate.courses()

      return result
    },
  })
}
